import React, { useState, useEffect } from "react";

import { Dialog, Card } from "@mui/material";
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from "../Buttons/Button";
import { useIsMobile } from "../../helpers/customHooks";
import { copyToClipboard } from "../../helpers/helperFunctions";
import NewButton from "../Buttons/NewButton";
import toast from "react-hot-toast";

const ApiAccessModal = ({show, data, type, onClose, onSave}) => {
	const MOBILE = useIsMobile();
	const { t } = useTranslation();
	const [hidden, setHidden] = useState(true)
	
	const refreshToken = () => {
        const data = {action: "regenerate"}
		onSave(data)
	}

	const copyText = () => {
		copyToClipboard(data?.token).then((result) => {
			toast.success(t("toast.success"))
		})
		.catch((error) => {
			console.error("Copy failed:", error); // trigger failure action
		});
	}

	const apiKeyContent = () => {
		return (
			<div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
						{/* <img src={icons.gear_code} alt="" /> */}
						<h3 className="">{t("settings.api_key")}</h3>
					</div>
					<img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." />
				</div>
				<p className="grey-blue py-3">{t("settings.api_key_desc")}</p>
				<form>
					<div className="form-group d-flex align-items-center position-relative bg-light-grey rounded24">
						<input
							type={hidden ? "password" : "text"}
							className="form-control p-3 pe-5 rounded24 grey-blue"
							id="password"
							value={data.token ?? ""}
							placeholder=""
							readOnly={true}
						/>
						<img src={hidden ? icons.eye_slashed : icons.eye_open} onClick={() => setHidden(!hidden)} className="inp-link-icon position-absolute size_15 ms-2 cursor-pointer end-0 me-2" alt="" />
					</div>
				</form>
				<div className="d-flex flex-row justify-content-end align-items-center mt-3">
					<NewButton onClick={() => refreshToken()} className="bg-grey-blue p-3 rounded24 w-100 white body bold">{t("settings.refresh")}</NewButton>
                </div>

				<div className="d-flex flex-row justify-content-end align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-50 dark-grey body bold me-2">{t("settings.close")}</NewButton>
					<NewButton onClick={() => copyText()} className="bg-gradient p-3 rounded24 w-50 white-white body bold ms-2">{t("settings.copy")}</NewButton>
                </div>
			</div>
		);
	};


	const typeRender = () => {
		switch (type) {
			case "key":
				return apiKeyContent();
			case "documentation":
				return apiKeyContent();
			default:
				return null;
		}
	};

	return (
		<>
			<Dialog fullWidth={MOBILE ? true : false} open={show} onClose={() => onClose()}>
				<Card className="settings-dialog d-flex flex-column scrollable-y">
					<div className="w-100 h-100 grey-blue">{typeRender()}</div>
				</Card>
			</Dialog>
		</>
	);
};

export default ApiAccessModal;
